/**
 * QuickSearch — the topbar's Cmd-K affordance.
 *
 * V1.0.x is the visual placeholder; the wired version owns its own state
 * (open / query / results) and lands together with `ai.askYourBusiness`
 * (the procedure that turns natural-language queries into navigable
 * record matches).
 *
 * Kept in its own file so:
 *   - the topbar's composition stays a single screen-height of code
 *   - the eventual `useQuickSearch` hook + Cmd-K dialog have a home
 *   - the `hidden md:flex` responsive rule is owned by the same component
 *     that owns the input — both belong together.
 */
import { Search } from "lucide-react";

export function QuickSearch() {
  return (
    // `bg-bg` default → `bg-paper` + sky ring on focus; matches brand-spec
    // §11 input states. `mx-auto` centres the search within the topbar's
    // remaining flex track.
    <label className="hidden md:flex items-center gap-2 flex-1 max-w-md h-9 px-3 rounded-sm border border-line bg-bg focus-within:border-sky-600 focus-within:bg-paper focus-within:ring-2 focus-within:ring-sky-100 transition-colors mx-auto">
      <Search size={14} strokeWidth={2} aria-hidden className="text-muted shrink-0" />
      <input
        type="search"
        placeholder="Quick search · jump to record"
        aria-label="Quick search"
        className="flex-1 min-w-0 bg-transparent border-0 outline-0 text-sm placeholder:text-muted text-ink"
      />
      <kbd className="font-mono text-xs px-1.5 py-0.5 rounded bg-paper border border-line-2 text-muted shrink-0 leading-none">
        ⌘ K
      </kbd>
    </label>
  );
}
